/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.buttongroup[_ngcontent-%COMP%], .entrypanel[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%], .smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-bottom:10px}.entrypanel[_ngcontent-%COMP%]{padding:15px}.mat-column-Actions[_ngcontent-%COMP%]{-webkit-box-flex:2;-ms-flex:2;flex:2;text-align:center}.buttonpad[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/manageterms/manageterms.component.css.shim.ngstyle.js.pre-build-optimizer.js